import { render } from "./Video.vue?vue&type=template&id=0aaff2b6&scoped=true"
import script from "./Video.vue?vue&type=script&lang=js"
export * from "./Video.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0aaff2b6"

export default script